import {createAction} from "redux-act";
import {ApiError} from "modules/utils";
import {BoosterType} from "modules/enums";

export interface ITeamPlayer {
	playerID: number | null;
	position: number;
}

export interface IBooster {
	id: number;
	swingId: number;
	eventId: number;
	type: BoosterType;
}

export interface IAutoSwap {
	id: number;
	roundId: number;
	eventId: number;
	movedFromBenchPlayerId: number | null;
	movedFromLineupPlayerId: number | null;
	isMovedCaptain: boolean;
}

export interface IAutoSub {
	id: number;
	eventId: number;
	outPlayerId: number;
	inPlayerId: number;
	isCaptainWithdrawn: boolean;
}

export interface ITeam {
	id: number;
	name: string;
	lineup: number[];
	bench: number[];
	players: ITeamPlayer[];
	captain: number | null;
	start_event_id?: number;
	withdrawn: number[] | null;
	points: number | null;
	event_rank: number | null;
	overall_rank: number | null;
	overall_points: number | null;
	scoreflow: Record<number, number>;
	round_scoreflow: Record<number, Record<number, number>>;
	selections: Record<number, number>;
	createdAt: string;
	boosters: IBooster[];
	isTeamCreated?: boolean;
	autoswaps?: IAutoSwap[];
	autosubs?: IAutoSub[];
}

export interface IRequestedTeamPayload {
	team: ITeam;
	eventID: number;
	hasUnsavedChanges?: boolean;
}

export const requestMyTeam = createAction<{eventID: number; roundID?: number}>();
export const requestMyTeamSuccess = createAction<IRequestedTeamPayload>();
export const autofillSuccess = createAction<IRequestedTeamPayload>();
export const requestMyTeamFailed = createAction<ApiError>();

export interface IRequestedRivalTeamPayload {
	userID: number;
	eventID: number;
	roundId?: number;
}

export const requestRivalTeam = createAction<IRequestedRivalTeamPayload>();
export const requestRivalTeamSuccess = createAction<IRequestedTeamPayload>();
export const requestRivalTeamFailed = createAction<ApiError>();

export const clearTeam = createAction<number>();

export const autoFillTeam = createAction<number>();
export const autoFillTeamSuccess = createAction<IRequestedTeamPayload>();
export const autoFillTeamFailed = createAction<ApiError>();

export const saveTeam = createAction<number>();
export const saveTeamFromLocalStorage = createAction<number>();
export const saveTeamSuccess = createAction<IRequestedTeamPayload>();
export const saveTeamFailed = createAction<ApiError>();
export const hideSaveTeamSuccessModal = createAction();

interface ITeamActionPayload {
	eventID: number;
	playerID: number | null;
}

export const setCaptain = createAction<ITeamActionPayload>();
export const addPlayerToTeam = createAction<ITeamActionPayload>();
export const removePlayerFromTeam = createAction<ITeamActionPayload>();
export const updateTeamLineup = createAction<{players: ITeamPlayer[]; eventID: number}>();

export const showPlayerModal = createAction<number>();
export const hidePlayerModal = createAction();

export const clearTeamsByID = createAction();
export const clearWithdrawn = createAction<number>();

export const saveBooster = createAction<BoosterType>();
export const saveBoosterSuccess = createAction<{booster: IBooster; eventID: number}>();
export const saveBoosterFailed = createAction();
export const removeBooster = createAction<number>();
export const removeBoosterSuccess = createAction<{boosterId: number; eventID: number}>();
export const removeBoosterFailed = createAction();
